import React from 'react';

import * as S from './styled';

import { IconNameType, IIcon } from './types';

import { ICONS } from './svgComponents';

// TODO: rm unused icons
const Icon = ({ mb, name, size = 16, focused, disabled, secondary, type = 'informational', libColor }: IIcon) => {
    if (libColor && type === 'actionable') {
        console.error('please stop using the libColor value with a "actionable" type');
    }
    if (secondary && type !== 'actionable') {
        console.error('please stop using secondary state with no "actionable" type');
    }

    const getIcon = () => {
        // TODO: make it default
        const DEFAULT_ICON = 'search';
        const isValidName = Object.keys(ICONS).includes(name);
        const icon: IconNameType = isValidName ? name : DEFAULT_ICON;

        if (!isValidName) {
            console.error(`Wrong Icon name: ${name}`);
        }

        return ICONS[icon]();
    };

    return (
        <S.Container
            disabled={disabled}
            type={type}
            size={size}
            name={name}
            mb={mb}
            focused={focused}
            libColor={libColor || 'text-main'}
            secondary={secondary}
        >
            {getIcon()}
        </S.Container>
    );
};

export { Icon };
